<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss" scoped>
body {
  background:rgba(240,241,245,1) !important;
  min-width: 1200px;
  width: 100%;
  height: 100%;
  #app {
    height: 100%;
  }
}
</style>
